import safeDriver from 'views/screens/SafeDriver/sidebarLayout';

const appsChildren = [...safeDriver];

export default [
  {
    header: 'sidebar.apps',
    iconName: 'BarChart2',
    children: appsChildren // Only to check permission in children inside
  },
  ...appsChildren
];
